/**
 * The team's S3 source connections, assigned by staff (TRA-922).
 *
 * [] for most teams: the "submit from your bucket" button (New batch on a
 * pipeline page) gates on this list, so visibility is data-driven with no
 * config fork. Same unwrap
 * pattern as useEvals.ts (the orval FETCH client returns
 * {data, status, headers}).
 */

import type { ApiRequestError } from '@/api/client'
import { useListConnectionsApiConnectionsGet } from '@/api/generated/connections/connections'
import type { TeamConnectionsResponse } from '@/api/generated/model'

interface UnwrappedQuery<TData> {
  data: TData | undefined
  isLoading: boolean
  error: ApiRequestError | null
  isError: boolean
}

export function useTeamConnections(): UnwrappedQuery<TeamConnectionsResponse> {
  const query = useListConnectionsApiConnectionsGet()
  return {
    data: query.data?.status === 200 ? query.data.data : undefined,
    isLoading: query.isLoading,
    error: query.error ?? null,
    isError: query.isError,
  }
}
